'use strict';

export { WorkletsModule } from "./WorkletsModule/index.js";
//# sourceMappingURL=index.js.map